import { getUserInfoFromCookie } from '../../../utils/env/getUserInfoFromCookie';
import { biErrorLoggerConsumer, updateBiGlobalInfo } from './consumers/biErrorLoggerConsumer';
import { sentryConsumer, updateSentryGlobalInfo } from './consumers/sentryConsumer';
import { ErrorLogger } from './ErrorLogger';
import { TIncomingMMGRSettings } from '../../../utils/hoc/withMMGRSettings/withMMGRSettings.types';

export { BI_ERRORS } from './BI_ERRORS';

export const errorLogger: ErrorLogger = new ErrorLogger().subscribe(biErrorLoggerConsumer).subscribe(sentryConsumer);
export const errorLoggerBiOnly: ErrorLogger = new ErrorLogger().subscribe(biErrorLoggerConsumer);

export function updateLoggers({
  userId = getUserInfoFromCookie().userId,
  metaSiteId,
  mmgrSettings,
}: { userId?: string; metaSiteId?: string; mmgrSettings?: Partial<TIncomingMMGRSettings> } = {}) {
  const { name } = getUserInfoFromCookie();

  updateSentryGlobalInfo({ name, userId, metaSiteId, mmgrSettings });

  if (metaSiteId) {
    updateBiGlobalInfo({ metaSiteId });
  }
}

updateLoggers();
